import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { HyperFlowChatbotService } from '../services/hyperflow-chatbot/hyperflow-chatbot.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard {
  constructor(
    private authServiceUser: AuthenticationService,
    private router: Router,
    private chatbotService: HyperFlowChatbotService
  ) {}
  canActivate(): boolean {
    if (!this.authServiceUser.isLoggedIn()) {
      this.authServiceUser.logoff();
      return false;
    }

    return true;
  }
}
